import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // for using ngModel directive
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { PanelModule } from 'primeng/panel';
import { AccordionModule } from 'primeng/accordion';

import { HisSharedModule } from 'hisng';

import { JobAdvertisementDetailViewComponent } from './component/jobadvertisement-detail-view.component';
import { JobAdvertisementSearchResultComponent } from './component/jobadvertisement-search-result.component';
import { JobAdvertisementSearchResultListComponent } from './component/jobadvertisement-search-result-list.component';

/**
 * SharedModule for jobadvertisements.
 */
@NgModule( {
    imports: [
        // Angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        // PrimeNG
        AutoCompleteModule,
        PanelModule,
        AccordionModule,

        // HIS
        HisSharedModule
    ],

    declarations: [
        JobAdvertisementDetailViewComponent,
        JobAdvertisementSearchResultComponent,
        JobAdvertisementSearchResultListComponent
    ],

    exports: [
        JobAdvertisementDetailViewComponent,
    ]

    // NO PROVIDERS! Providers need to go into JobAdvertisementCoreModule
} )
export class JobAdvertisementSharedModule {
}
